export const nl = {
  translation: {
    'page title': 'Welcome to the broker studio',
  },
  system: {
    linkedItem: {
      claim: 'Claim',
      insurance: 'Verzekering',
      quotation: 'Offerte',
      customer: 'Klant',
    },
    tags: {
      claim: {
        in_progress: 'In behandeling',
        in_review: 'Wachten op derden',
        is_closed: 'Uitbetaald',
        is_cancelled: 'Geweigerd',
        in_concept: 'In concept',
      },
      quotation: {
        sent: 'Verzonden',
        accepted: 'Geaccepteerd',
        expired: 'Verlopen',
        rejected: 'Afgewezen',
        cancelled: 'Geannuleerd',
        concept: 'Concept',
        pending: 'In behandeling',
        ready: 'Klaar',
        deleted: 'Verwijderd',
        revised: 'In bewerking',
      },
      insurance: {
        active: 'Actief',
        cancelled: 'Geroyeerd',
        needs_review: 'In review',
        active_pending: 'In afwachting',
        cancelled_pending: 'In afwachting',
        not_current_version: 'Niet de laatste versie',
      },
      taskPriority: {
        low: 'Laag',
        medium: 'Gemiddeld',
        high: 'Hoog',
        critical: 'Kritiek',
      },
      taskStatus: {
        postponed: 'In afwachting',
        in_progress: 'In uitvoering',
        closed: 'Afgerond',
        in_review: 'Open',
      },
      customer: {
        active: 'Actief',
        prospect: 'Prospect',
        inactive: 'Inactief',
      },
      payment: {
        paid: 'Betaald',
        unpaid: 'Openstaand',
        expired: 'Verlopen',
      },
    },
  },
};
